import { Injectable } from '@angular/core';
import { Router, NavigationEnd, NavigationStart, NavigationError } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class RouteExtService {

  private previousUrl: string = undefined;
  private currentUrl: string = undefined;
  private historyURL = [];
 
  constructor(private router : Router) {
    this.currentUrl = this.router.url;
    
    
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        // Show loading indicator
        console.log(event.url);
      }
      if (event instanceof NavigationError) {
        // Present error to user
        console.log(event.error);
      }

      if (event instanceof NavigationEnd) {   
        this.previousUrl = this.currentUrl;
        this.currentUrl = event.url;
        this.insertHistory({
          previousUrl:this.previousUrl,
          currentUrl:this.currentUrl
        }); 
      };
    });
  }

  public insertHistory(obj){
    this.historyURL.push(obj);
    if(this.historyURL.length > 30){
      this.historyURL.shift();
    }
    console.log(this.historyURL);
  }

  public getPreviousUrl(){
    return this.previousUrl;
  }
  public getCurrentUrl(){
    return this.currentUrl;
  }
}
